<template>
  <v-card
    class="mx-auto"
    max-width="800"
  >
    <v-card-title>
        <v-icon class="pr-1" color="red" size="35">mdi-hand-heart-outline</v-icon>
        <v-toolbar-title>
            <h2 class="text-h6 pl-2 font-weight-bold">Thank you for your support.</h2>
        </v-toolbar-title>
        <v-spacer></v-spacer>
    </v-card-title>
    <v-divider/>
    <v-card-subtitle class="pb-0">Donation Link:</v-card-subtitle>
    <v-card-text class="pb-0">
        <div>{{donationLinkText}}</div>
    </v-card-text>
    <v-divider class="mx-4"></v-divider>

    <v-card-actions>
    <v-btn
        block
        class="white--text"
        color="blue accent-4"
        v-clipboard="donationLinkText"
        @click="snackbar = true"
    >
        Copy to Clipboard
        <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            color="success"
            elevation-24
        >
            Donation Link Copied
        </v-snackbar>
    </v-card-actions>
  </v-card>
</template>

<script>
    export default {
        data: () => ({
            donationLinkText: 'https://www.paypal.com/donate?business=donations@kcparkfriends.org&no_recurring=0& \
            item_name=Friends+of+the+Park&item_number=Fall+Cleanup+Campaign&amount=25&currency_code=USD',
            snackbar: false,
            timeout: 2000,
        }),
    }
  </script>